
  import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

  @Component
  export default class General extends Vue  {
    dialog = false
    editDateMenu = false
    menu = false
    headers = [
      {
        text: 'Date',
        align: 'start',
        value: 'date',
      },
      { text: 'File Name', value: 'originalDocName' },
      { text: 'Notes', value: 'notes' },
      { text: 'Number of Sheets', value: 'numOfSheets' },
      { text: 'As Built', value: 'asBuilt' },
      //{ text: 'URL', value: 'url' },
      { text: 'Actions', value: 'actions', sortable: false },
    ]
    items: Array<object> = []
    editedIndex = -1
    editedItem: any = {
      id: null,
      date: '',
      notes: '',
      numOfSheets: 1,
      asBuilt: false,
      url: '',
      pdf: null,
      bridgeId: -1
    }
    defaultItem: any = {
      id: null,
      date: '',
      notes: '',
      numOfSheets: 1,
      asBuilt: false,
      url: '',
      pdf: null,
      bridgeId: -1
    }

    @Prop() readonly id!: object
    @Prop() readonly tab!: number

    //Methods
    public editItem(item: object ): void {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    }

    public close(): void {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    }

    public deleteItem(item: object): void {
      confirm('Are you sure you want to delete this item?') && this.$store.dispatch('bridge/deleteBridgePlan', item)
    }

    public download(item: object): void {
      this.$store.dispatch('bridge/downloadBridgePlan', item)
    }

    public viewPDF(item: object): void {
      this.$store.dispatch('bridge/openBridgePlanPDF', item)
    }

    public save(): void {
      this.editedItem.bridgeId = this.id
      this.doCrudBridgePlan(this.editedIndex)
    }

    public async doCrudBridgePlan(index: any): Promise<any> {
      const response = null
      if (index > -1) {
        await this.$store.dispatch('bridge/updateBridgePlan', this.editedItem)
        //Object.assign(this.items[this.editedIndex], this.editedItem)
      } else {
        await this.$store.dispatch('bridge/storeBridgePlan', this.editedItem)
        //this.items.push(this.editedItem)
      }
      this.close()
    }

    //Getters
    get getBridgePlans(): any {
      return this.$store.getters['bridge/getBridgePlans']
    }
    get getReload(): boolean {
      return this.$store.getters['bridge/getReload']
    }
    get getLoading(): boolean {
      return this.$store.getters['bridge/getLoading']
    }
    get getMessage(): string {
      return this.$store.getters['bridge/getMsg']
    }
    get getErrors(): Array<string> {
      return this.$store.getters['bridge/getErrors']
    }
    get getDeletePermissions(): string {
      return this.$store.getters['auth/getPermissions'].includes('Bridge Admin')
    }
    get getEditPermissions(): string {
      return this.$store.getters['auth/getPermissions'].includes('Bridge Editor') ||
              this.$store.getters['auth/getPermissions'].includes('Bridge Admin')
    }

    //Watchers
    @Watch('getReload')
    reload(val: boolean) {
      if(val && this.tab == 3) {
        this.$store.dispatch('bridge/getBridgePlans', { id: this.id })
        this.$store.commit('bridge/setReload', false)
      }
    }
    @Watch('getBridgePlans')
    setItems(val: any) {
      this.items = val
    }
  }



